import { useState } from "react";
import Logo from "./Components/Logo/Logo";
import NavigationButton from "./Components/Navigation/NavigationButton";
import Social from "./Components/Social/Social";
import Drawer from "./Components/Drawer/Drawer";
import SwitchLanguage from "./Components/SwitchLanguage/SwitchLanguage";
import { useTranslation } from "react-i18next";
const Header = () => {
  const [drawerIsActive, setDrawerIsActive] = useState(false);

  const drawerHandler = () => {
    setDrawerIsActive((cur) => !cur);
  };

  const { t, i18n } = useTranslation();

  return (
    <header className="bg-white fixed drop-shadow-2xl top-0 left-0  w-full z-[100000]">
      <div
        className={`  ${
          i18n.language === "ar"
            ? "right-container-header "
            : "left-container-header"
        }  `}
      >
        <div className="flex items-stretch justify-between ">
          <Logo />
          <div className="flex items-centser gap-x-8 min-h-full ">
            <Social />
            <div className="hidden xl:block">
              <SwitchLanguage isHeader={true} />
            </div>
            <NavigationButton onClick={drawerHandler} />

            <Drawer onHandleDrawer={drawerHandler} isActive={drawerIsActive} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
